import { useBreakpointValue } from '@genial/utils';

import { SentOrderDetailResponseNormalized } from '../../../../../store/rateManagement/selector';

import { CardDesktop } from './Desktop';
import { CardMobile } from './Mobile';
import { CardTablet } from './Tablet';

export namespace CardTypes {
  export interface Props {
    sentOrderDetail?: SentOrderDetailResponseNormalized | null;
    loading?: boolean;
  }
}

export const Card = (props: CardTypes.Props) => {
  return useBreakpointValue({
    base: <CardMobile {...props} />,
    sm: <CardTablet {...props} />,
    md: <CardDesktop {...props} />,
  });
};
